export const translations = {
  en: {
    nav: { home: "Home", products: "Products", about: "Our Story", b2b: "B2B", contact: "Contact", cart: "Cart" },
    common: { exploreProducts: "Explore Products", contactUs: "Contact Us", addToCart: "Add to Cart", added: "Added", requestQuote: "Request Quote", submit: "Send", learnMore: "Learn more", viewAll: "View all", readOurStory: "Read Our Story" },
    hero: {
      eyebrow: "Mexican × Nordic",
      title1: "Authentic Mexican Flavor.",
      title2: "Crafted in Finland.",
      subtitle: "Premium Mexican sauces, ingredients, and food products inspired by the flavors, traditions, and street food culture of Mexico.",
      slogan: "Drip it. Dip it. Love it.",
    },
    discover: {
      eyebrow: "Our Story",
      title: "Crafted in Finland.\nInspired by Mexico.",
      body: "Garnacha is a Mexican word for street food, flavor, tradition, and character. Founded by Eduardo, a Mexican chef in Finland, we bring real, honest recipes from the streets of Mexico to Nordic tables.",
    },
    productsSection: {
      eyebrow: "Our Products",
      title: "Authentic Mexican products\nfor modern kitchens.",
      intro: "Carefully crafted, thoughtfully selected, and made without artificial additives. Every Garnacha product is vegan and gluten-free.",
      sauces: "Sauces",
      chilies: "Dry Chiles",
      corn: "Corn Products",
      saucesDesc: "Small-batch salsas built on real ingredients and a Mexican chef's hand.",
      chiliesDesc: "Sun-dried, hand-sorted chiles, the foundation of any Mexican kitchen.",
      cornDesc: "Stone-ground masa and signature blends for tortillas, antojitos and beyond.",
      featuredEyebrow: "Featured Products",
      flagship: "Flagship",
      heatLabel: "Heat",
      recommendedFor: "Recommended for",
    },
    why: {
      eyebrow: "Why Garnacha",
      title: "Why Garnacha?",
      f1t: "Authentic Mexican Recipes", f1b: "Built on real, honest recipes from a Mexican chef.",
      f2t: "Crafted in Finland", f2b: "Produced in Finland with care.",
      f3t: "Carefully Selected Ingredients", f3b: "Each ingredient chosen for flavor, character and integrity.",
      f4t: "Traditional Flavors", f4b: "Recipes rooted in Mexican home cooking and street food.",
      f5t: "Consistent Quality", f5b: "Every batch tastes the way it should, every time.",
      f6t: "Inspired by Mexican Street Food", f6b: "Flavor, tradition, character, the spirit of la garnacha.",
    },
    future: {
      eyebrow: "The Future of Garnacha",
      title: "A long-term brand.\nNot a single product.",
      sub: "Garnacha begins with premium products. Over time, it will grow into a Mexican food universe in the Nordics.",
      p1t: "Premium Mexican Products", p1b: "Sauces, chilies and corn, the foundation of the brand.",
      p2t: "Garnacha Taquería", p2b: "A flagship restaurant honoring real street-style taquerías.",
      p3t: "Garnacha Food Truck", p3b: "Mobile, fast, the soul of Mexico on Nordic streets.",
      p4t: "Garnacha Café & Churros", p4b: "Coffee, chocolate and freshly fried churros.",
      p5t: "Garnacha Bar Concept", p5b: "Mezcal, tequila and Mexican-inspired cocktails.",
      phase: "Phase",
    },
    about: {
      eyebrow: "Our Story",
      title1: "Our Story.",
      title2: "A piece of Mexico.",
      p1: "Garnacha is a very Mexican word, a way of describing street food that's full of flavor, tradition, and character.",
      p2: "Our mission is simple: to bring the true taste of Mexican street food to new tables without losing its authenticity.",
      p3: "Founded by Eduardo, a Mexican passionate about cooking and culture, Garnacha is built on real, honest recipes inspired by the streets, markets, and everyday life in Mexico.",
      p4: "In Mexico, food is more than just something you eat, it brings people together. It's about sharing, connecting, and gathering friends and family around the table.",
      pull1: "We don't try to imitate.",
      pull2: "We aim to represent.",
      closing: "Because real Mexican food isn't just spicy or colorful, it's memory, identity, tradition, and true flavor.",
      missionEyebrow: "Mission",
      mission: "To bring the true taste of Mexican street food to new tables without losing its authenticity.",
      visionEyebrow: "Vision",
      vision: "To build a recognized Mexican food brand inspired by authentic Mexican flavors, quality ingredients, and the culture of sharing food.",
      tagline1: "Crafted in Finland.",
      tagline2: "Inspired by Mexico.",
    },
    b2b: {
      eyebrow: "B2B",
      title: "Made for\nProfessional Kitchens.",
      sub: "Garnacha products are designed to help restaurants, food trucks, caterers, and chefs deliver authentic Mexican flavor with consistency and convenience.",
      formatsTitle: "Available Formats",
      formatsIntro: "Garnacha products are available in multiple formats depending on product category and customer needs.",
      retailLabel: "Retail",
      retail: "250 ml Glass Bottle",
      horecaLabel: "Horeca",
      horeca: "2.5 L Food Service Format",
      formats: [
        {
          id: "sauces",
          name: "Sauces",
          rows: [
            { label: "Retail", value: "250 ml Glass Bottle" },
            { label: "Horeca", value: "2.5 L Food Service Format" },
          ],
          productsLabel: "Available Products",
          products: ["Salsa Verde Habanero", "Salsa Verde Taquera", "Salsa Chipotle Taquera", "Mango Habanero"],
        },
        {
          id: "chilies",
          name: "Dry Chiles",
          rows: [
            { label: "Food Service Format", value: "Available by kilogram." },
          ],
          productsLabel: "Available Products",
          products: ["Guajillo", "Chipotle", "Chile de Árbol", "Habanero"],
          suitableLabel: "Suitable for",
          suitable: ["Restaurants", "Caterers", "Food Production", "Professional Kitchens"],
        },
        {
          id: "corn",
          name: "Corn Products",
          rows: [
            { label: "Food Service Format", value: "20 kg Bags" },
          ],
          productsLabel: "Available Products",
          products: ["White Corn Flour", "Yellow Corn Flour", "Garnacha Masa Mix"],
          suitableLabel: "Suitable for",
          suitable: ["Tortillas", "Tostadas", "Tamales", "Mexican Food Production"],
        },
      ],
      customTitle: "Custom Sauce Development",
      customBody: "Looking for a unique sauce for your restaurant or food concept? We can work together to develop custom recipes tailored to your menu, flavor profile, and operational needs.",
      benefits: "Why Work with Garnacha?",
      b: [
        { t: "Authentic Mexican Recipes", d: "Built on real, honest recipes from a Mexican chef." },
        { t: "Consistent Flavor", d: "Every batch tastes the way it should." },
        { t: "Ready-to-Use Solutions", d: "From bottle to plate with minimal handling." },
        { t: "Horeca Focused", d: "Designed for the realities of professional kitchens." },
        { t: "Flexible Development", d: "Custom recipes for your concept and menu." },
        { t: "Reliable Local Production", d: "Made in Finland with care and precision." },
      ],
      ctaHeading: "Let's create something together.",
      cta: "Contact Us",
      formTitle: "Get in touch",
      sent: "Thank you, we'll be in touch within 2 business days.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      sub: "Sales, samples, partnerships, we read every message.",
      name: "Name", company: "Company", email: "Email", phone: "Phone", message: "Message",
      type: "Reason for contact",
      types: { sales: "Contact Sales", samples: "Request Samples", partner: "Become a Partner", general: "General Inquiry" },
      send: "Send Message",
      sent: "Thank you, we'll reply within 2 business days.",
      directTitle: "Reach us directly",
      phoneLabel: "Phone",
      phoneValue: "+358 44 973 8964",
      instagram: "@thisisgarnacha",
      tiktok: "@thisisgarnacha",
      facebook: "This Is Garnacha",
      website: "www.garnacha.fi",
    },
    shop: {
      eyebrow: "Shop",
      title: "Order with intent.",
      sub: "Add products to your cart, then send us a quote request. We'll confirm availability and pricing for your market.",
      empty: "Your cart is empty.",
      yourCart: "Your Cart",
      subtotal: "Subtotal",
      checkout: "Send Quote Request",
      remove: "Remove",
      filterAll: "All", filterSauces: "Sauces", filterChilies: "Chilies", filterCorn: "Corn",
      heat: "Heat",
      size: "Size",
      quoteFormTitle: "Send quote request",
      quoteSent: "Quote request sent. We'll confirm within 1 business day.",
    },
    footer: {
      tagline: "Drip it. Dip it. Love it.™",
      madeIn: "Crafted in Finland. Inspired by Mexico.",
      links: "Navigate",
      social: "Follow",
      legal: "© 2025 GARNACHA®. All rights reserved.",
    },
  },
  fi: {
    nav: { home: "Etusivu", products: "Tuotteet", about: "Tarinamme", b2b: "Yrityksille", contact: "Yhteystiedot", cart: "Ostoskori" },
    common: { exploreProducts: "Tutustu tuotteisiin", contactUs: "Ota yhteyttä", addToCart: "Lisää koriin", added: "Lisätty", requestQuote: "Pyydä tarjous", submit: "Lähetä", learnMore: "Lue lisää", viewAll: "Katso kaikki", readOurStory: "Lue tarinamme" },
    hero: {
      eyebrow: "Meksikolainen × Pohjoismainen",
      title1: "Aitoa meksikolaista makua.",
      title2: "Valmistettu Suomessa.",
      subtitle: "Premium-luokan meksikolaisia kastikkeita, raaka-aineita ja ruokatuotteita — inspiraationa Meksikon maut, perinteet ja katuruokakulttuuri.",
      slogan: "Drip it. Dip it. Love it.",
    },
    discover: {
      eyebrow: "Tarinamme",
      title: "Valmistettu Suomessa.\nInspiraationa Meksiko.",
      body: "Garnacha on meksikolainen sana katuruoalle — maku, perinne ja luonne. Suomessa asuvan meksikolaisen kokin Eduardon perustamana tuomme aidot, rehelliset reseptit Meksikon kaduilta pohjoismaiseen pöytään.",
    },
    productsSection: {
      eyebrow: "Tuotteemme",
      title: "Aitoja meksikolaisia tuotteita\nmoderniin keittiöön.",
      intro: "Huolella valmistettuja, harkiten valittuja ja ilman keinotekoisia lisäaineita. Jokainen Garnacha-tuote on vegaaninen ja gluteeniton.",
      sauces: "Kastikkeet",
      chilies: "Kuivatut chilit",
      corn: "Maissituotteet",
      saucesDesc: "Pieninä erinä valmistetut salsat aidoista raaka-aineista ja meksikolaisen kokin käsistä.",
      chiliesDesc: "Aurinkokuivatut, käsin lajitellut chilit — meksikolaisen keittiön perusta.",
      cornDesc: "Kivijauhettua masaa ja signature-sekoituksia tortilloihin, antojitoihin ja muuhun.",
      featuredEyebrow: "Suositellut tuotteet",
      flagship: "Lippulaiva",
      heatLabel: "Tulisuus",
      recommendedFor: "Suositellaan",
    },
    why: {
      eyebrow: "Miksi Garnacha",
      title: "Miksi Garnacha?",
      f1t: "Aidot meksikolaiset reseptit", f1b: "Meksikolaisen kokin aidoille, rehellisille resepteille rakennettu.",
      f2t: "Valmistettu Suomessa", f2b: "Suomessa valmistettu huolella, tarkkuudella ja moderneilla standardeilla.",
      f3t: "Huolella valitut raaka-aineet", f3b: "Jokainen raaka-aine valittu maun, luonteen ja eheyden perusteella.",
      f4t: "Perinteiset maut", f4b: "Reseptit juurtuneet meksikolaiseen kotiruokaan ja katuruokaan.",
      f5t: "Tasalaatuinen laatu", f5b: "Jokainen erä maistuu kuten sen kuuluukin — joka kerta.",
      f6t: "Meksikolaisen katuruoan inspiroima", f6b: "Maku, perinne, luonne — la garnachan henki.",
    },
    future: {
      eyebrow: "Garnachan tulevaisuus",
      title: "Pitkän aikavälin brändi.\nEi yksi tuote.",
      sub: "Garnacha alkaa premium-tuotteista. Ajan myötä se kasvaa meksikolaisen ruoan universumiksi Pohjoismaissa.",
      p1t: "Premium-meksikotuotteet", p1b: "Kastikkeet, chilit ja maissi — brändin perusta.",
      p2t: "Garnacha Taquería", p2b: "Lippulaivaravintola katuruoan hengessä.",
      p3t: "Garnacha Food Truck", p3b: "Liikkuva, nopea — Meksikon sielu pohjoisilla kaduilla.",
      p4t: "Garnacha Café & Churros", p4b: "Kahvi, suklaa ja juuri paistetut churrot.",
      p5t: "Garnacha Bar -konsepti", p5b: "Mezcal, tequila ja meksikolaiset cocktailit.",
      phase: "Vaihe",
    },
    about: {
      eyebrow: "Tarinamme",
      title1: "Tarinamme.",
      title2: "Pala Meksikoa.",
      p1: "Garnacha on hyvin meksikolainen sana — tapa kuvata katuruokaa, joka on täynnä makua, perinnettä ja luonnetta.",
      p2: "Tehtävämme on yksinkertainen: tuoda aito meksikolaisen katuruoan maku uusiin pöytiin menettämättä sen alkuperäisyyttä.",
      p3: "Garnachan perusti Eduardo, meksikolainen ruoanlaiton ja kulttuurin intohimon mies. Brändi rakentuu aitojen, rehellisten reseptien varaan — Meksikon katujen, torien ja arjen inspiroimana.",
      p4: "Meksikossa ruoka on enemmän kuin syömistä — se yhdistää ihmiset. Se on jakamista, kohtaamista ja perheen sekä ystävien kokoontumista pöydän ääreen.",
      pull1: "Emme yritä jäljitellä.",
      pull2: "Edustamme.",
      closing: "Sillä aito meksikolainen ruoka ei ole vain tulista tai värikästä — se on muistoa, identiteettiä, perinnettä ja todellista makua.",
      missionEyebrow: "Missio",
      mission: "Tuoda aito meksikolaisen katuruoan maku uusiin pöytiin menettämättä sen alkuperäisyyttä.",
      visionEyebrow: "Visio",
      vision: "Rakentaa tunnustettu meksikolainen ruokabrändi — aidoista mauista, laadukkaista raaka-aineista ja ruoan jakamisen kulttuurista inspiroituneena.",
      tagline1: "Valmistettu Suomessa.",
      tagline2: "Inspiraationa Meksiko.",
    },
    b2b: {
      eyebrow: "B2B",
      title: "Tehty\nammattikeittiöille.",
      sub: "Garnachan tuotteet on suunniteltu auttamaan ravintoloita, food truckeja, pitopalveluja ja kokkeja tuomaan aitoa meksikolaista makua tasalaatuisesti ja vaivattomasti.",
      formatsTitle: "Saatavilla olevat pakkauskoot",
      formatsIntro: "Garnachan tuotteet ovat saatavilla useissa pakkauskoissa tuoteryhmän ja asiakkaan tarpeiden mukaan.",
      retailLabel: "Vähittäismyynti",
      retail: "250 ml lasipullo",
      horecaLabel: "Horeca",
      horeca: "2,5 l food service -koko",
      formats: [
        {
          id: "sauces",
          name: "Kastikkeet",
          rows: [
            { label: "Vähittäismyynti", value: "250 ml lasipullo" },
            { label: "Horeca", value: "2,5 l food service -koko" },
          ],
          productsLabel: "Saatavilla olevat tuotteet",
          products: ["Salsa Verde Habanero", "Salsa Verde Taquera", "Salsa Chipotle Taquera", "Mango Habanero"],
        },
        {
          id: "chilies",
          name: "Kuivatut chilit",
          rows: [
            { label: "Food service -koko", value: "Saatavilla kiloittain." },
          ],
          productsLabel: "Saatavilla olevat tuotteet",
          products: ["Guajillo", "Chipotle", "Chile de Árbol", "Habanero"],
          suitableLabel: "Sopii",
          suitable: ["Ravintolat", "Pitopalvelut", "Elintarviketuotanto", "Ammattikeittiöt"],
        },
        {
          id: "corn",
          name: "Maissituotteet",
          rows: [
            { label: "Food service -koko", value: "20 kg pussit" },
          ],
          productsLabel: "Saatavilla olevat tuotteet",
          products: ["Valkoinen maissijauho", "Keltainen maissijauho", "Garnacha Masa Mix"],
          suitableLabel: "Sopii",
          suitable: ["Tortillat", "Tostadat", "Tamalit", "Meksikolaisen ruoan tuotanto"],
        },
      ],
      customTitle: "Räätälöity kastikekehitys",
      customBody: "Etsitkö ainutlaatuista kastiketta ravintolaasi tai ruokakonseptiisi? Voimme kehittää yhdessä reseptin, joka sopii menuusi, makuprofiiliisi ja toiminnallisiin tarpeisiisi.",
      benefits: "Miksi Garnacha?",
      b: [
        { t: "Aidot meksikolaiset reseptit", d: "Meksikolaisen kokin aidoille resepteille rakennettu." },
        { t: "Tasalaatuinen maku", d: "Jokainen erä maistuu kuten sen kuuluukin." },
        { t: "Valmiit ratkaisut", d: "Pullosta lautaselle — minimaalisella käsittelyllä." },
        { t: "Horeca-keskeinen", d: "Suunniteltu ammattikeittiöiden todellisuuteen." },
        { t: "Joustava kehitys", d: "Räätälöidyt reseptit konseptiisi ja menuusi." },
        { t: "Luotettava paikallinen tuotanto", d: "Valmistettu Suomessa huolella ja tarkkuudella." },
      ],
      ctaHeading: "Luodaan jotain yhdessä.",
      cta: "Ota yhteyttä",
      formTitle: "Ota yhteyttä",
      sent: "Kiitos — palaamme asiaan kahden työpäivän kuluessa.",
    },
    contact: {
      eyebrow: "Yhteystiedot",
      title: "Otetaan yhteyttä.",
      sub: "Myynti, näytteet, kumppanuudet — luemme jokaisen viestin.",
      name: "Nimi", company: "Yritys", email: "Sähköposti", phone: "Puhelin", message: "Viesti",
      type: "Yhteydenoton syy",
      types: { sales: "Ota yhteyttä myyntiin", samples: "Pyydä näytteitä", partner: "Tule kumppaniksi", general: "Yleinen kysely" },
      send: "Lähetä viesti",
      sent: "Kiitos — vastaamme kahden työpäivän kuluessa.",
      directTitle: "Tavoita meidät suoraan",
      phoneLabel: "Puhelin",
      phoneValue: "+358 44 973 8964",
      instagram: "@thisisgarnacha",
      tiktok: "@thisisgarnacha",
      facebook: "This Is Garnacha",
      website: "www.garnacha.fi",
    },
    shop: {
      eyebrow: "Kauppa",
      title: "Tilaa harkiten.",
      sub: "Lisää tuotteet ostoskoriin ja lähetä meille tarjouspyyntö. Vahvistamme saatavuuden ja hinnan markkinasi mukaan.",
      empty: "Ostoskorisi on tyhjä.",
      yourCart: "Ostoskorisi",
      subtotal: "Välisumma",
      checkout: "Lähetä tarjouspyyntö",
      remove: "Poista",
      filterAll: "Kaikki", filterSauces: "Kastikkeet", filterChilies: "Chilit", filterCorn: "Maissi",
      heat: "Tulisuus",
      size: "Koko",
      quoteFormTitle: "Lähetä tarjouspyyntö",
      quoteSent: "Tarjouspyyntö lähetetty. Vahvistamme yhden työpäivän kuluessa.",
    },
    footer: {
      tagline: "Drip it. Dip it. Love it.™",
      madeIn: "Valmistettu Suomessa. Inspiraationa Meksiko.",
      links: "Sivut",
      social: "Seuraa",
      legal: "© 2025 GARNACHA®. Kaikki oikeudet pidätetään.",
    },
  },
};
